<template>
  <Teleport to="body">
    <div class="pointer-events-none fixed left-1/2 top-6 z-[2147483647] flex w-[min(28rem,calc(100vw-2rem))] -translate-x-1/2 flex-col gap-3">
      <TransitionGroup name="toast">
        <div
          v-for="toast in toastStore.toasts"
          :key="toast.id"
          class="pointer-events-auto flex items-start gap-3 rounded-xl border p-4 shadow-lg backdrop-blur-sm"
          :class="toastClasses(toast.variant)"
        >
          <span class="mt-0.5 flex-shrink-0">
            <svg
              v-if="toast.variant === 'success'"
              class="h-5 w-5 text-emerald-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
            <svg
              v-else-if="toast.variant === 'error'"
              class="h-5 w-5 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
            <svg
              v-else-if="toast.variant === 'warning'"
              class="h-5 w-5 text-amber-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
              />
            </svg>
            <svg v-else class="tb-ci-text-accent h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </span>

          <p class="flex-1 text-sm font-medium">{{ toast.message }}</p>

          <button
            type="button"
            class="flex-shrink-0 text-gray-400 transition-colors hover:text-gray-600 dark:hover:text-gray-200"
            @click="toastStore.remove(toast.id)"
          >
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { useToastStore } from '@/stores/toast'
import type { ToastVariant } from '@/stores/toast'

const toastStore = useToastStore()

function toastClasses(variant: ToastVariant): string {
  return {
    success:
      'border-emerald-200 bg-white text-gray-900 dark:border-emerald-800 dark:bg-gray-900 dark:text-white',
    error: 'border-red-200 bg-white text-gray-900 dark:border-red-800 dark:bg-gray-900 dark:text-white',
    warning:
      'border-amber-200 bg-white text-gray-900 dark:border-amber-800 dark:bg-gray-900 dark:text-white',
    info: 'tb-ci-toast-info',
  }[variant]
}
</script>

<style scoped>
.toast-enter-active,
.toast-leave-active {
  transition:
    opacity 0.3s ease,
    transform 0.3s ease;
}
.toast-enter-from {
  opacity: 0;
  transform: translateY(-12px) scale(0.96);
}
.toast-leave-to {
  opacity: 0;
  transform: translateY(-12px) scale(0.96);
}
</style>
